(function(){
    'use strict';
    angular.module('app').controller('VehicleTypesController', VehicleTypesController);

    VehicleTypesController.$inject = ['$scope', 'FleetVehicleTypesTableService'];

    function VehicleTypesController($scope, FleetVehicleTypesTableService) {

        const vm = this;

        init();

        function init() {
            const paginationData = {
                size: 5,
                page: 0,
                sort: 'id'
            };
            getVehicleTypes(paginationData);

        }

        function getVehicleTypes() {
            vm.vehicleTypesTableData = new FleetVehicleTypesTableService().tableData;
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/VehicleTypesController.js